module.exports = __webpack_public_path__ + "static/media/spinnericon.be1b60bd.gif";